import * as React from 'react';
import { Colors, Breakpoints } from '../../shared/styles/StyleConst';

const OnsenYadoSearchResultPlaceholder = () => (
  <div className="loading-overall-placeholder">
    <div className="placeholder placeholder--image" />
    <div className="label-container">
      <div className="placeholder placeholder--label1" />
      <div className="placeholder placeholder--label2" />
    </div>
    <div className="price-container">
      <div className="placeholder placeholder--price" />
    </div>
    <style jsx>
      {`
        .loading-overall-placeholder {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: ${Colors.white};
          display: flex;
          flex-wrap: wrap;
        }
        .label-container {
          flex: 2;
        }
        .price-container {
          flex: 1;
        }
        .placeholder {
          position: relative;
          overflow: hidden;
          background-color: ${Colors.onsenGray400};
        }
        .placeholder::after {
          background-color: ${Colors.onsenGray200};
          content: ' ';
          display: block;
          position: absolute;
          top: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          transform: translateX(0);
          animation-duration: 1.75s;
          animation-timing-function: ease-in-out;
          animation-delay: 0s;
          animation-iteration-count: infinite;
          animation-direction: normal;
          animation-fill-mode: none;
          animation-name: wave;
        }
        .placeholder--image {
          height: 100%;
          width: 184px;
        }
        .placeholder--label1 {
          margin: 15px 10px 0;
          height: 15px;
        }
        .placeholder--label2 {
          margin: 15px 40px 0 10px;
          height: 15px;
        }
        .placeholder--price {
          margin: 60px 10px 0 0;
          height: 20px;
        }
        @media screen and (max-width: ${Breakpoints.smMax}) {
          .placeholder--image {
            width: 100%;
            height: 40%;
          }
        }
        @keyframes wave {
          0% {
            transform: translateX(-100%);
          }
          50% {
            transform: translateX(0);
          }
          to {
            transform: translateX(100%);
          }
        }
      `}
    </style>
  </div>
);

export default OnsenYadoSearchResultPlaceholder;
